const ApiAttributesKeys = {
  chapterIdKey: 'id',
  chapterNameKey: 'chapter_name',
  videoTableNameKey: 'frm_videos',
  lastVideoViewTableNameKey: 'frm_video',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Videos/ApiAttributesKays.js